import React from 'react'
import videojs from 'video.js'
import get from 'lodash/get'
import 'video.js/dist/video-js.css'
import { throttle } from 'lodash'

export default class VideoPlayer extends React.Component {
  componentDidMount() {
    // instantiate Video.js
    const blogId = get(this.props, 'blogId')
    const patientId = get(this.props, 'patientId')
    const sourceType = get(this.props, 'sourceType')

    const { updateVideoAnalysis: mutate } = this.props
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      this.on('loadedmetadata', function () {
        // _that.playTimer.duration = this.duration()
      })

      this.on('play', function () {
        if (this.currentTime() === 0) {
          mutate({
            variables: {
              blogId,
              patientId,
              type: 'PLAY',
              sourceType,
              duration: this.duration(),
            },
          })
        }
      })

      function handleCallback() {
        mutate({
          variables: {
            blogId,
            patientId,
            type: 'PROCESS',
            sourceType,
            duration: this.duration(),
            process: this.currentTime(),
          },
        })
      }
      this.on('ended', handleCallback)
      this.on('timeupdate', throttle(handleCallback, 5000))
    })
  }

  // destroy player on unmount
  componentWillUnmount() {
    console.log('Video', 'componentWillUnmount', this.props)
    if (this.player) {
      this.player.dispose()
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute so videojs won't
  // create additional wrapper in the DOM see
  // https://github.com/videojs/video.js/pull/3856

  render() {
    return (
      <div>
        <div
          data-vjs-player
          style={{
            width: '100%',
            height: '200px',
            clear: 'both',
            display: 'block',
          }}
        >
          <video
            webkit-playsinline
            ref={(node) => (this.videoNode = node)}
            className="video-js"
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/videoPlayer.js